import { $, aviso, avisoHtml, el, esc, escribir, limpiar, noContesto, num, pedir, puede, repintar, rpc, sb, trabado, trabarSiNoContesto, YO } from './nucleo';
import { ERROR_CLIENTES } from './clientes';
import { ERROR_PRODUCTOS, PRODUCTOS } from './catalogo';
import { catalogosCobro, celdaCobro } from './cobros';
import { buscaEntregados, cargarCircuito, irADevolver, transicionesLeidas } from './circuito';
import { ofrecerPedirAprobacion } from './aprobaciones';
import { avisarCorte } from './ajustes';
import { abrirVenta } from './venta';

export let PEDIDOS = [], RENGLONES = [];
//  Lo mismo para la lista de pedidos: mientras tenga texto, la tabla dice
//  que no se pudo leer en vez de afirmar que no hay ninguno.
export let ERROR_PEDIDOS = '';

// ---------- catálogos del pedido ----------
let METODOS = [];
let PRODU = {};

//  Lo que NO se pudo leer, que no es lo mismo que lo que no hay. Son DOS
//  banderas porque cierran puertas distintas (regla 11): sin formas de entrega
//  no se confirma un pedido; sin monedas no se carga la cotización del día.
//  Juntarlas trabaría el pedido por un select de otra tarjeta.
//  Ninguna relación se tapa por permiso (RLS = `app.es_usuario()`): un `error`
//  acá es siempre una falla de verdad, no hay nada que preguntarle a `puede()`.
export let ERROR_METODOS = '',   //  `metodos_entrega`: confirmar el pedido y cambiar la entrega
           ERROR_MONEDAS = '';   //  `monedas`: la cotización del día

//  El texto nombra lo que sí existe y no se pudo ver: "no hay ninguna forma
//  de entrega cargada" manda a configurar algo que ya está configurado.
const porQue = (e: string, hay: string) =>
  `No se pudieron leer ${hay} (${esc(e)}). <b>No es que no haya: es que no ` +
  'se pudieron leer.</b> Cambiá de pestaña y volvé, o recargá con Ctrl+F5.';

//  La puerta del pedido es el botón de confirmar: "Nuevo pedido" NO es un
//  `<form>`, no hay Enter que se la salte. En la cotización sí hay form, y allá
//  el freno está en el `submit` (regla 9). Evita un cartel que le echa la culpa
//  a la persona ("Falta decir cómo se entrega" sobre un select sin opciones).
//
//  Mira DOS banderas (formas de entrega y clientes) que escriben dos cargas en
//  paralelo. Ojo: la cuenta vive en una función y **cada carga la llama después
//  de escribir su bandera**; escribirla adentro de una sola sería la carrera de
//  la regla 13.
//  `ERROR_CLIENTES` es de `clientes.ts` (regla 1): acá se lee, no se escribe.
export function puertaPedido(){
  const roto = ERROR_METODOS || ERROR_CLIENTES;
  $('#btnConfirmar').disabled = !!roto || trabado('#btnConfirmar');
  //  Cada cartel al lado de su select.
  if (ERROR_METODOS)
    avisoHtml('#pedEntMsg', 'bad', porQue(ERROR_METODOS, 'las formas de entrega') +
      '<br>Mientras tanto no se puede confirmar ningún pedido: de la forma de ' +
      'entrega depende si hay que empaquetarlo o si el cliente lo pasa a buscar.');
  else limpiar('#pedEntMsg');
  if (ERROR_CLIENTES)
    avisoHtml('#pedCliMsg', 'bad', porQue(ERROR_CLIENTES, 'los clientes') +
      '<br>Mientras tanto no se puede confirmar ningún pedido: sin la lista no ' +
      'se sabe a quién se le está vendiendo.');
  else limpiar('#pedCliMsg');
}

//  El tipo de entrega decide por qué rama del circuito va el pedido, así
//  que no puede quedar sin definir: la base lo rechaza (0023).
export async function cargarMetodos(){
  const { data, error } = await pedir(sb.from('metodos_entrega')
    .select('id,nombre,tipo').eq('activo',true).order('orden'));
  ERROR_METODOS = error ? error.message : '';
  //  Con error `data` es null y esto vacía `METODOS`, a propósito: llena
  //  también el select de "Cambiar entrega" y no debe ofrecer métodos que ya
  //  no se pueden afirmar.
  METODOS = data || [];
  //  La opción vacía va primera y SIEMPRE (regla 10): sin ella el select
  //  arranca con un método elegido por nadie y el `required` no frena.
  repintar('#peEntrega', ERROR_METODOS
    ? '<option value="">no se pudieron leer las formas de entrega</option>'
    : '<option value="">Elegí cómo se entrega…</option>' +
      METODOS.map(x => `<option value="${x.id}">${esc(x.nombre)}</option>`).join(''));
  puertaPedido();
}

//  Las monedas extranjeras de la cotización del día. El select lo llena esto
//  (cualquiera con `pedido.ver`): no es una puerta, es un catálogo.
export async function cargarMonedas(){
  const { data, error } = await pedir(sb.from('monedas')
    .select('id,codigo,nombre').eq('es_base',false).order('orden'));
  ERROR_MONEDAS = error ? error.message : '';
  const monedas = data || [];
  //  La opción vacía va primera y SIEMPRE (regla 10): sin ella la primera viene
  //  elegida por nadie, y esta cotización se estampa en cada cobro.
  repintar('#cotMoneda', ERROR_MONEDAS
    ? '<option value="">no se pudieron leer las monedas</option>'
    : `<option value="">${monedas.length ? '— elegí la moneda —'
                                         : 'No hay monedas extranjeras cargadas'}</option>` +
      monedas.map(x =>
        `<option value="${x.id}">${esc(x.codigo)} — ${esc(x.nombre)}</option>`).join(''));
  //  Sin moneda que elegir no hay cotización que cargar, con error o sin él
  //  (`data` null deja la lista vacía). La condición es una sola a propósito:
  //  `ERROR_MONEDAS ||` no agregaría nada. Los estados se distinguen en lo que
  //  se DICE: una lista vacía de verdad es legítima, no una falla.
  $('#btnCotiz').disabled = !monedas.length;
  if (ERROR_MONEDAS) avisoHtml('#cotCatMsg', 'bad', porQue(ERROR_MONEDAS, 'las monedas'));
  else limpiar('#cotCatMsg');
}

export async function cargarCatalogosPedido(){
  //  En paralelo: son consultas independientes.
  await Promise.all([cargarMetodos(), cargarMonedas()]);
  pintarSelectProductos();
  pintarRenglones();
  //  Por el envoltorio con caché: los catálogos de cobro se leen UNA vez y el
  //  reintento vale para todas las pantallas que los usan.
  await catalogosCobro();
}

//  El reintento al abrir la pestaña, por destino: sin falla no consulta nada,
//  y si falló una sola, no relee la otra.
export function reintentarPedidos(){
  if (ERROR_METODOS) cargarMetodos();
  if (ERROR_MONEDAS) cargarMonedas();
  //  El panel de cotizaciones también, o su cartel quedaría pegado (regla 9).
  //  Costo: si se cayó `monedas`, se pide dos veces (lecturas independientes).
  if (ERROR_COTIZ) cargarCotizaciones();
}

export function pintarSelectProductos(){
  PRODU = {};
  PRODUCTOS.forEach(p => PRODU[p.id] = p);
  const elegido = $('#peProd').value;
  //  Una lista que no se pudo leer no es una lista vacía: "no hay productos
  //  cargados todavía" mandaría a dar de alta algo que ya existe (la regla del 4/9).
  $('#peProd').innerHTML = ERROR_PRODUCTOS
    ? '<option value="">no se pudieron leer los productos</option>'
    : PRODUCTOS.length
    //  Arranca vacío (pedido de Steven, 1/11, D216): sin la opción vacía
    //  quedaba elegido el primero del catálogo sin que nadie lo eligiera.
    ? '<option value="">— elegí el producto —</option>' +
      PRODUCTOS.map(p => `<option value="${p.id}">${esc(p.codigo)} — ${esc(p.descripcion)}</option>`).join('')
    : '<option value="">No hay productos cargados todavía</option>';
  if (elegido && PRODU[Number(elegido)]) $('#peProd').value = elegido;
  //  La puerta se cierra donde está el acto (no culpar a la persona con "Elegí
  //  un producto").
  $('#btnAgregar').disabled = !!ERROR_PRODUCTOS;
  //  Ojo: el aviso va en su PROPIO div, no en `#pedMsg`, que escriben otros
  //  nueve lugares y pisarían la explicación (como `#recCatMsg` en Recepción).
  if (ERROR_PRODUCTOS)
    aviso('#pedCatMsg','bad', `No se pudieron leer los productos (${ERROR_PRODUCTOS}). ` +
      'No es que no haya ninguno: es que no se pudieron leer. Cambiá de pestaña ' +
      'y volvé, o recargá con Ctrl+F5.');
  else limpiar('#pedCatMsg');
  sugerirPrecio();
}
function sugerirPrecio(){
  const p = PRODU[Number($('#peProd').value)];
  $('#pePrecio').value = !p ? ''
    : (p.precio_vigente != null ? num(p.precio_vigente) : 'sin precio de lista');
}
$('#peProd').onchange = sugerirPrecio;

// ---------- cotización ----------
//  El panel de "cotización del día" lo arman DOS consultas que afirman lo
//  mismo, así que la bandera es una sola (tan fina como la puerta, regla 11).
//  Ojo: `monedas` no llena nada visible, sólo filtra CUÁLES cotizaciones se
//  muestran; si cae, el panel saldría vacío con las cotizaciones bien leídas e
//  invitaría a cargar la de hoy de nuevo.
let ERROR_COTIZ = '';

export async function cargarCotizaciones(){
  const [coti, mone] = await Promise.all([
    pedir(sb.from('v_cotizaciones_vigentes').select('*')),
    pedir(sb.from('monedas').select('codigo').eq('es_base', false))
  ]);
  ERROR_COTIZ = coti.error ? coti.error.message
              : mone.error ? mone.error.message : '';
  if (ERROR_COTIZ){
    $('#cotizActual').innerHTML =
      `<div class="hint">No se pudieron leer las cotizaciones (${esc(ERROR_COTIZ)}). ` +
      'No quiere decir que no haya ninguna cargada.</div>';
    return;
  }
  const extranjeras = new Set((mone.data||[]).map(m => m.codigo));
  $('#cotizActual').innerHTML = (coti.data||[]).filter(c => extranjeras.has(c.codigo)).map(c => `
    <div><div class="hint">${esc(c.codigo)}</div>
         <b>${c.valor ? num(Number(c.valor)) : '—'}</b>
         <div class="hint">${c.rige_desde
            ? new Date(c.rige_desde).toLocaleString('es-AR') : 'sin cargar'}</div>
    </div>`).join('');
}

$('#formCotiz').onsubmit = async e => {
  e.preventDefault();
  limpiar('#cotizMsg');
  //  Acá hace falta el freno además del botón apagado: esto ES un `<form>` y
  //  un Enter lo manda igual (regla 9); `Number('')` es NaN.
  if (ERROR_MONEDAS){
    aviso('#cotizMsg','bad','No se pudieron leer las monedas, así que no se sabe ' +
      'en cuál se está cargando la cotización. Cambiá de pestaña y volvé, o ' +
      'recargá con Ctrl+F5.');
    return;
  }
  //  El freno que la opción vacía hace posible (`Number('')` es NaN).
  if (!$('#cotMoneda').value){
    //  Y el tercer estado dice lo suyo: con cero monedas extranjeras
    //  configuradas, "elegí una" es una instrucción que no se puede cumplir.
    //  Es el mismo cartel que le echa la culpa a la persona, una tarjeta más
    //  abajo.
    aviso('#cotizMsg','bad', $('#cotMoneda').options.length > 1
      ? 'Elegí en qué moneda estás cargando la cotización.'
      : 'No hay ninguna moneda extranjera configurada, así que no hay nada que ' +
        'cotizar. Se cargan en la base, con la moneda de catálogo.');
    return;
  }
  const { error } = await escribir(sb.from('cotizaciones').insert({
    moneda_id  : Number($('#cotMoneda').value),
    valor      : Number($('#cotValor').value),
    nota       : $('#cotNota').value.trim() || null,
    cargada_por: YO.id
  }));
  //  Si la base no contestó, la cotización quizá quedó cargada (D92): se
  //  relee la tabla de vigentes, que es donde se ve.
  if (noContesto(error)){
    aviso('#cotizMsg','warn', error.message +
      ' Fijate en las cotizaciones vigentes antes de cargarla de nuevo.');
    cargarCotizaciones();
    return;
  }
  if (error){ aviso('#cotizMsg','bad', error.message); return; }
  aviso('#cotizMsg','ok','Cotización cargada. Rige desde ahora.');
  $('#formCotiz').reset();
  cargarCotizaciones();
};

// ---------- renglones del pedido ----------
$('#btnAgregar').onclick = e => {
  e.preventDefault();
  const id = Number($('#peProd').value);
  const p  = PRODU[id];
  const precio = p ? Number(p.precio_vigente) : NaN;
  if (!p){ aviso('#pedMsg','bad','Elegí un producto.'); return; }
  if (!Number.isFinite(precio)){
    aviso('#pedMsg','bad','Ese producto no tiene precio de lista. Cargalo en Precios y volvé.');
    return;
  }
  RENGLONES.push({
    producto_id: id, codigo: p.codigo, descripcion: p.descripcion,
    cantidad: Math.max(1, Number($('#peCant').value) || 1),
    precio_unitario: precio,
    descuento: Number($('#peDesc').value) || 0
  });
  $('#peCant').value = '1'; $('#peDesc').value = '0';
  //  El renglón siguiente también arranca sin producto.
  $('#peProd').value = ''; sugerirPrecio();
  pintarRenglones();
};

function netoRenglon(r){ return r.precio_unitario * r.cantidad - r.descuento; }

function pintarRenglones(){
  $('#tblRenglones').innerHTML = RENGLONES.map((r,i) => `
    <tr><td><span class="mono">${esc(r.codigo)}</span> ${esc(r.descripcion)}${
          //  0111 (D235): lo que tiene IMEI va de a un equipo por renglón;
          //  la base lo parte al confirmar, con el descuento repartido.
          r.cantidad > 1 && PRODU[r.producto_id]?.es_serializado
            ? ` <span class="hint" data-por-equipo>· va en ${r.cantidad} renglones, uno por equipo (cada uno con su IMEI)</span>` : ''}</td>
        <td class="num">${r.cantidad}</td>
        <td class="num">${num(r.precio_unitario)}</td>
        <td class="num">${r.descuento ? num(r.descuento) : '—'}</td>
        <td class="num"><b>${num(netoRenglon(r))}</b></td>
        <td><div class="fila-acc"><button class="b b-sec" data-quitar="${i}">Quitar</button></div></td></tr>
  `).join('') || '<tr><td colspan="6" class="vacio">Agregá al menos un renglón</td></tr>';
  $('#peTotal').textContent = num(RENGLONES.reduce((a,r) => a + netoRenglon(r), 0));
}

$('#tblRenglones').onclick = e => {
  const b = el(e.target).closest('[data-quitar]');
  if (!b) return;
  RENGLONES.splice(Number(b.dataset.quitar), 1);
  pintarRenglones();
};

$('#btnConfirmar').onclick = async e => {
  e.preventDefault();
  limpiar('#pedMsg');
  if (!RENGLONES.length){ aviso('#pedMsg','bad','El pedido no tiene renglones.'); return; }
  if (!$('#peCliente').value){ aviso('#pedMsg','bad','Elegí un cliente.'); return; }
  if (!$('#peEntrega').value){
    aviso('#pedMsg','bad','Falta decir cómo se entrega: de eso depende si hay que empaquetarlo o si el cliente lo pasa a buscar.');
    return;
  }
  const btn = $('#btnConfirmar'); btn.disabled = true;
  const { data, error } = await rpc('crear_pedido', {
    p_cliente_id: Number($('#peCliente').value),
    p_items: RENGLONES.map(r => ({
      producto_id: r.producto_id, cantidad: r.cantidad,
      precio_unitario: r.precio_unitario, descuento: r.descuento })),
    p_metodo_entrega_id: Number($('#peEntrega').value),
    p_notas: $('#peNotas').value.trim() || null,
    p_requiere_caja_cerrada: $('#peCaja').checked,
    p_prioridad: $('#pePrioridad').value,
    p_descuento_pedido: 0
  });
  //  Un pedido que no contestó quizá quedó creado: el botón no vuelve hasta
  //  que se entre de nuevo a la pestaña, que relee la lista (D91, D92).
  btn.disabled = false;
  trabarSiNoContesto('#btnConfirmar', error);
  if (error){
    aviso('#pedMsg','bad', error.message);
    ofrecerPedirAprobacion(error.message);
    return;
  }
  aviso('#pedMsg','ok', data.mensaje);
  const cardAp = document.getElementById('cardPedirAp');
  if (cardAp) cardAp.remove();
  //  Y la del corte (0100, D219), que tiene su propio id.
  document.getElementById('cardPedirCorte')?.remove();
  RENGLONES = []; pintarRenglones();
  $('#peNotas').value = ''; $('#peCaja').checked = false;
  cargarPedidos();
  if (puede('item','cambiar_estado')) cargarCircuito();
};

// ---------- lista de pedidos ----------
//  LA LECTURA EN VIAJE, para quien llega desde otra pestaña y tiene que abrir
//  algo en la lista (`irACobros`, D183): espera ésta en vez de disparar otra.
let LEYENDO: Promise<void> = Promise.resolve();
export const leyendoPedidos = () => LEYENDO;

export function cargarPedidos(){
  return (LEYENDO = leerPedidos());
}

async function leerPedidos(){
  //  Reintento de los catálogos de cobro (dicen en qué moneda está el saldo).
  //  Se espera ANTES de pintar, o la tabla sale con el rótulo viejo.
  await catalogosCobro();
  //  El corte del día: se avisa ANTES de completar medio pedido (0037). No
  //  frena nada (la puerta está en la base, D11) y no se espera.
  avisarCorte('#avisoCorte');
  const { data, error } = await pedir(sb.from('v_pedidos').select('*')
    .order('ocurrido_en', { ascending: false }).limit(TOPE_PEDIDOS));
  //  Avisar no alcanza: la tabla que afirma es la que tiene que desdecirse
  //  (regla 5). `PEDIDOS` se vacía porque de ahí salen los botones de cobrar y
  //  cambiar la entrega: no ofrecer actos sobre filas que no se pueden afirmar.
  ERROR_PEDIDOS = error ? error.message : '';
  PEDIDOS = data || [];
  pintarPedidos();
  transicionesLeidas()?.then(agregarVolvio);
}

//  La lista trae los últimos TOPE_PEDIDOS: si llegaron todos, puede haber más
//  atrás, y el buscador (que filtra sólo los que llegaron) lo tiene que decir
//  en lugar de «ningún pedido coincide» (D122).
export const TOPE_PEDIDOS = 200;
export const pedidosCortados = () => !ERROR_PEDIDOS && PEDIDOS.length >= TOPE_PEDIDOS;

const CHIP_PEDIDO = { activo:'c-pen', finalizado:'c-ok', anulado:'c-bad', borrador:'c-warn' };

//  Todo pedido tiene cliente (`pedidos.cliente_id` es NOT NULL): si llega en
//  null es que `clientes_ver` lo tapó, y un «—» se leería como «sin cliente»
//  (136). Lo mismo que dice Equipos.
const celdaCliente = (p: any) => p.cliente
  ? `<td>${esc(p.cliente)}</td>`
  : '<td class="hint" title="Este cliente no lo podés ver"><span class="chip c-warn">no lo ves</span></td>';

//  «VOLVIÓ ALGO» (D183): el atajo al buscador de Entregados del Circuito, para
//  quien lo ve, en los pedidos que tienen algo ya cerrado (`items` contra
//  `items_abiertos`; si lo cerrado no es Entregado, el buscador lo dice).
const botonVolvio = (p: any) =>
  buscaEntregados() && Number(p.items || 0) > Number(p.items_abiertos || 0)
    ? ` <button class="b b-sec" data-volvio="${esc(p.codigo)}"
         title="Busca en Circuito lo que este pedido tiene en Entregado">Volvió algo</button>` : '';

function pintarPedidos(){
  if (ERROR_PEDIDOS){
    $('#tblPedidos').innerHTML = `<tr><td colspan="8" class="vacio">` +
      `No se pudieron leer los pedidos (${esc(ERROR_PEDIDOS)}). ` +
      `No quiere decir que no haya ninguno.</td></tr>`;
    return;
  }
  const q = ($('#buscaPed').value || '').toLowerCase();
  const f = PEDIDOS.filter(p => !q ||
    [p.codigo, p.cliente, p.vendedor].some(x => (x||'').toLowerCase().includes(q)));
  $('#tblPedidos').innerHTML = (f.map(p => `
    <tr data-ped="${p.id}"><td class="mono"><a href="#" data-abrir="${p.id}"
          title="Abrir la venta"><b>${esc(p.codigo)}</b></a>${
          p.prioridad === 'urgente' ? ' <span class="chip c-bad">urgente</span>' : ''}</td>
        ${celdaCliente(p)}
        <td>${esc(p.vendedor || '—')}</td>
        <td>${esc(p.metodo_entrega || '—')}${
          p.tipo_entrega && p.tipo_entrega !== 'retiro'
            ? ' <span class="chip c-pen">se empaqueta</span>' : ''}${
          puede('pedido','editar') && p.estado === 'activo'
            ? ` <button class="b b-sec" data-entrega="${p.id}">Cambiar</button>` : ''}</td>
        <td class="num">${p.items}${p.items_faltantes
            ? ` <span class="chip c-warn">${p.items_faltantes} falta</span>` : ''}</td>
        <td><span class="chip ${CHIP_PEDIDO[p.estado]||'c-pen'}">${esc(p.estado)}</span></td>
        <td class="num"><b>${num(Number(p.neto||0))}</b></td>
        <td>${celdaCobro(p)}${botonVolvio(p)}</td></tr>
  `).join('') || (PEDIDOS.length
    //  Con pedidos y el filtro sin coincidencias, «Todavía no hay pedidos»
    //  mentiría: lo que no hay es coincidencia.
    ? `<tr><td colspan="8" class="vacio">${pedidosCortados()
        ? `Ninguno de los últimos ${num(TOPE_PEDIDOS)} pedidos coincide con «${esc(q)}»: puede estar entre los anteriores.`
        : `Ningún pedido coincide con «${esc(q)}».`}</td></tr>`
    : '<tr><td colspan="8" class="vacio">Todavía no hay pedidos</td></tr>'))
    + (pedidosCortados()
        ? `<tr><td colspan="8" class="hint"><span class="chip c-warn">puede haber más</span> `
          + `Se muestran los últimos ${num(TOPE_PEDIDOS)} pedidos; el buscador busca sólo entre ellos.</td></tr>`
        : '');
}

//  «Volvió algo» depende de las transiciones, que se leen en paralelo al
//  arrancar (166): si llegan después que los pedidos, se agrega el botón en
//  su fila sin repintar la tabla (repintar se llevaría un panel de cobro ya
//  abierto, por ejemplo el que abre `irACobros`).
function agregarVolvio(){
  if (ERROR_PEDIDOS) return;
  PEDIDOS.forEach(p => {
    const tr = $(`#tblPedidos tr[data-ped="${p.id}"]`);
    if (tr && !tr.querySelector('[data-volvio]'))
      tr.lastElementChild.insertAdjacentHTML('beforeend', botonVolvio(p));
  });
}
$('#buscaPed').oninput = pintarPedidos;

// Cambiar el tipo de entrega. Hasta cuándo se puede NO lo decide esta
// pantalla: la base lo permite mientras el pedido esté entero en Nuevo, y
// si no, contesta por qué.
$('#tblPedidos').onclick = e => {
  //  El código abre la ficha de la venta (D220).
  const ab = el(e.target).closest('[data-abrir]');
  if (ab){ e.preventDefault(); return abrirVenta(Number(ab.dataset.abrir)); }
  const v = el(e.target).closest('[data-volvio]');
  if (v) return irADevolver(v.dataset.volvio);
  const b = el(e.target).closest('[data-entrega]');
  if (!b) return;
  const p = PEDIDOS.find(x => x.id === Number(b.dataset.entrega));
  if (!p) return;
  //  Sin métodos legibles no se abre: un `<select>` vacío manda `Number('')`
  //  (método 0) y la base falla por clave foránea. Misma puerta que confirmar.
  const fila = b.closest('tr');
  if (fila.nextElementSibling?.id === 'filaEntrega'){ fila.nextElementSibling.remove(); return; }
  document.getElementById('filaEntrega')?.remove();

  const tr = document.createElement('tr');
  tr.id = 'filaEntrega';
  //  Sin métodos legibles no se arma (el `<select>` vacío mandaría el método 0).
  //  El aviso va en la fila, no en `#pedMsg` (lejos de la fila apretada), y se va
  //  al volver a apretar porque lleva el mismo id que el panel.
  if (ERROR_METODOS){
    tr.innerHTML = `<td colspan="8"><div class="aviso a-bad">No se pudieron leer ` +
      `las formas de entrega, así que no se puede cambiar la de este pedido. ` +
      `Cambiá de pestaña y volvé, o recargá con Ctrl+F5.</div></td>`;
    fila.after(tr);
    return;
  }
  tr.innerHTML = `<td colspan="8">
    <div class="confirmar">
      <div class="conf-tit">Entrega del pedido ${esc(p.codigo)}</div>
      <p class="conf-txt">Sólo se puede cambiar mientras el depósito no lo haya tocado.</p>
      <div class="fila-acc">
        <select id="ceMetodo">${METODOS.map(m =>
          `<option value="${m.id}"${m.id === p.metodo_entrega_id ? ' selected' : ''}>${esc(m.nombre)}</option>`).join('')}</select>
        <button class="b b-sec" id="ceCancelar">Cancelar</button>
        <button class="b b-pri" id="ceOk">Cambiar</button>
      </div>
    </div></td>`;
  fila.after(tr);
  $('#ceCancelar', tr).onclick = () => tr.remove();
  $('#ceOk', tr).onclick = async () => {
    limpiar('#pedMsg');
    const { data, error } = await rpc('cambiar_metodo_entrega', {
      p_pedido_id: p.id,
      p_metodo_entrega_id: Number($('#ceMetodo', tr).value)
    });
    if (error){ aviso('#pedMsg','bad', error.message); return; }
    tr.remove();
    aviso('#pedMsg','ok', data.mensaje);
    cargarPedidos();
    if (puede('item','cambiar_estado')) cargarCircuito();
  };
};
